import { IconBurgerInHand } from 'components/icons/burger-in-hand';

export const LoggedOutEmptyStateImage = IconBurgerInHand;
